import React, { useCallback } from 'react';
import { Button } from 'react-bootstrap';
import { BsPencil } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { unsubmitShipping } from '../../actions';
import { selectShippingCity } from '../../slices/shipping';

const CurrentRegionButton = () => {
    const dispatch = useDispatch();

    const handleClick = useCallback(() => {
        dispatch(unsubmitShipping());
    }, [dispatch]);

    const city = useSelector(selectShippingCity);

    return <Button variant="link" onClick={handleClick}>
        <BsPencil />
        &nbsp;
        {city}
    </Button>;
}

export default CurrentRegionButton;
